module.exports = __webpack_public_path__ + "img/sekanina.c4fbd233.jpg";